import React from 'react';
import {
  Paintbrush, ChefHat, ShowerHead, LayoutGrid, Layers, Wrench, Zap, Hammer,
  Droplet, Droplets, RefreshCw, ArrowLeftRight, Phone,
  Plug, Lightbulb, Sun, Search,
  Columns2, PanelTop, Ruler, DoorOpen,
  HelpCircle,
} from 'lucide-react';

const MAP = {
  Paintbrush,
  ChefHat,
  ShowerHead,
  LayoutGrid,
  Layers,
  Wrench,
  Zap,
  Hammer,
  Droplet,
  Droplets,
  RefreshCw,
  ArrowLeftRight,
  Phone,
  Plug,
  Lightbulb,
  Sun,
  Search,
  Columns2,
  PanelTop,
  Ruler,
  DoorOpen,
};

/**
 * Renders a Lucide icon by name string.
 * Falls back to HelpCircle if the name is unknown.
 */
export function CatIcon({ name, className = 'h-5 w-5' }) {
  const Icon = MAP[name] ?? HelpCircle;
  return <Icon className={className} />;
}
